/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Ai_Edit_PromptInputs */

const cs_property_ai_edit_prompt = /** @type {(inputs: Property_Ai_Edit_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upravit prompt`)
};

const en_property_ai_edit_prompt = /** @type {(inputs: Property_Ai_Edit_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit prompt`)
};

/**
* | output |
* | --- |
* | "Edit prompt" |
*
* @param {Property_Ai_Edit_PromptInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_ai_edit_prompt = /** @type {((inputs?: Property_Ai_Edit_PromptInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Ai_Edit_PromptInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_ai_edit_prompt(inputs)
	return cs_property_ai_edit_prompt(inputs)
});